
export class NsnAnnouncements {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    announcementsCount: number;
}
